export const KEYS = {
  DEFAULT: {
    THEMING_ERROR: 'Theming Fehler',
    ERROR_LOADING_CSS_THEME_FILE: 'Die für diese Domain konfigurierte Theme CSS Datei: <b>[[cssFilePath]]</b> konnte nicht geladen werden.'
  }
};
